export default "__VITE_ASSET__BNmTbPjy__";